import { Avatar, Container, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography, useTheme } from "@material-ui/core";
import React, { useState } from "react";
import { Map, Overlay, ZoomControl } from 'pigeon-maps'
import useAxios from "axios-hooks";
import { getURL } from '../helpers/url-helper';
import { AlertTypes, APIUrl } from "../Enums";
import { City } from "../models/City";
import { LoadingStar } from "../components/loading-star";
import { AppAlert } from "../components/app-alert";
import LocationCityRoundedIcon from '@material-ui/icons/LocationCityRounded';
import { Link } from "react-router-dom";
import { CanonicalLink, MapConfiguration, Paths } from "../helpers/constants";
import { CityMarker } from "../components/map/cityMarker";
import { isMobile } from 'react-device-detect';
import { MetaDecorator } from "../helpers/metaDecorator";
import ogMapImage from "../images/mapOG.jpg"
import { SearchHeader } from "../components/SearchHeader";
import { filterByName } from "../helpers/filterHelper";
import { EmptyListItem, MapViewBreadcrumbs } from "../components";

export const MapView = () => {
  const theme = useTheme();

  const [{ data, loading, error }] = useAxios<City[]>({
    method: 'GET',
    url: `${getURL(APIUrl.AllCities)}`
  });

  const [searchQuery, setSearchQuery] = useState("")

  const zoom = isMobile ? MapConfiguration.zoom.generalMap.mobile : MapConfiguration.zoom.generalMap.desktop

  const sortByAmount = (cityA?: City, cityB?: City) => (cityB?.locationsAmount || -1) - (cityA?.locationsAmount || -1)

  const citiesToDisplay = data?.filter(city => filterByName(city, searchQuery)).sort(sortByAmount)

  return (
    <>
      <MetaDecorator
        title="Muzyczna mapa Polski, zobacz gdzie powstawały rockowe hity"
        description="Rockowa mapa Polski, przedstawia miasta oraz lokalizacje związane z polskimi piosenkami rockowymi. Zobacz gdzie i jak komponowane były największe hity"
        canonicalLink={CanonicalLink.map}
        ogImage={ogMapImage} />
      <Container style={{ paddingTop: theme.spacing(8), paddingBottom: theme.spacing(8) }} maxWidth="md">
        <MapViewBreadcrumbs />
        <>
          {loading && <LoadingStar />}
          {error && error.message && <AppAlert text="Nie udało się pobrać mapy wraz z miastami" strongText="Prosimy spróbować ponownie" type={AlertTypes.Error} />}
          {data && data.length === 0 && !loading && <Typography variant="caption">Brak danych</Typography>}
          {data && data.length > 0 && (
            <>
              <Map
                height={MapConfiguration.height}
                defaultCenter={MapConfiguration.polishCenterPoint}
                center={MapConfiguration.polishCenterPoint}
                minZoom={zoom}
                zoom={zoom}>
                <ZoomControl />
                {data.map((city, index) => {
                  return (
                    <Overlay anchor={[city.latitude, city.longitude]} key={`marker-${index}`}>
                      <CityMarker city={city} />
                    </Overlay>
                  )
                })}
              </Map>
              <Grid item xs={12}>
                <SearchHeader placeHolderText="Wyszukaj miasto" setSearchQuery={setSearchQuery} />
                <>
                  <div style={{ overflow: 'auto', height: 325 }}>
                    <List>
                      {citiesToDisplay && citiesToDisplay.length > 0 && citiesToDisplay.map((city, index) => {
                        return (
                          <Link key={`key-for-link-${city.name}-${index}`} to={Paths.map.viewCity(city.link)} style={{ display: 'flex', textDecoration: "none", color: "inherit" }}>
                            <ListItem
                              key={`key-for-${city.name}-${city.id}`}
                            >
                              <ListItemAvatar>
                                <Avatar>
                                  <LocationCityRoundedIcon />
                                </Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={city.name}
                                secondary={` ${city.locationsAmount || 0} powiązanych piosenek`} />
                            </ListItem>
                          </Link>
                        );
                      })}
                      {
                        (!citiesToDisplay || citiesToDisplay.length === 0) && (<EmptyListItem />)
                      }
                    </List>
                  </div>
                </>
              </Grid>
            </>
          )}
        </>
      </Container>
    </>
  );
};
